import en from './business_settings.en';

const enConfig = { en };

export default enConfig;
